exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".two-factor-success-container{color:#000;font-size:14px;font-style:normal;font-weight:400;line-height:normal;text-align:center}.two-factor-success-container h2{color:#25282a;text-align:center;font-size:38px;font-style:normal;font-weight:700;line-height:36px}.two-factor-success-container h2 img{height:36px;width:auto;margin-right:12px}.two-factor-success-container .low-text{color:#666;text-align:center;font-size:14px;font-style:normal;font-weight:400;line-height:normal;margin-top:12px;margin-bottom:45px}.two-factor-success-container .submit-btn{display:flex;width:258px;height:34px;padding:10px;flex-direction:column;justify-content:center;align-items:center;gap:10px;border-radius:5px;box-shadow:0 4px 4px 0 rgba(0,0,0,.15);color:#fff;font-size:14px;font-style:normal;font-weight:700;line-height:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/auth/two-factor/two-factor-success.scss
// module id = 214
// module chunks = 0